import React, { useState, useEffect } from "react";
import "./css/myorder.scss";
import { Container, Button } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import { getOrderHistory } from "../../../../actions/myaccount/order/orderHistoryActions";
import { orderAgainApi } from "../../../../api/myaccount/order/orderAgainApi";
import img from "./img/noOrder.png";
// import img from "./img/no_booking_image.png";
import Spinner from "react-bootstrap/Spinner";
import { CiCalendarDate } from "react-icons/ci";
import { RiBox3Line } from "react-icons/ri";
import { MdOutlineArrowBackIos } from "react-icons/md";
import { OrderFlow } from "../../../../App";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";

export const reOrder = async (formData) => {
  try {
    const response = await orderAgainApi(formData);
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};
const ITEMS_PER_PAGE = 6;
const Yourorder = ({
  orderhistory,
  isLoading,
  error,
  userData,
  getOrderHistory,
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  // Calculate the index range for items on the current page
  const indexOfLastItem = currentPage * ITEMS_PER_PAGE;
  const indexOfFirstItem = indexOfLastItem - ITEMS_PER_PAGE;
  const currentItems = orderhistory?.message?.slice(
    indexOfFirstItem,
    indexOfLastItem
  );

  const { restaurant } = OrderFlow();
  const menuData = localStorage.getItem("menuData") || null;
  const restarantInfo = restaurant || JSON.parse(menuData);

  const totalPages = Math.ceil(orderhistory?.message?.length / ITEMS_PER_PAGE);

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };

  const [searchOrder, setSearchOrder] = useState(null);
  const [width, setWidth] = useState(window.innerWidth);
  const breakpoint = 992;
  const location = useLocation();

  useEffect(() => {
    const handleResizeWindow = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResizeWindow);
    return () => {
      window.removeEventListener("resize", handleResizeWindow);
    };
  }, []);

  const OrderDetailURL = "../orderdetail";
  const navigate = useNavigate();

  const navigateToOrderDetail = async (event) => {
    const GetOId = event.target.getAttribute("Oid");
    const GetCId = event.target.getAttribute("Cid");
    const GetPath = event.target.getAttribute("Path");
    navigate(OrderDetailURL, { state: { GetOId, GetCId, GetPath } });
  };

  const OrderStatusURL = "../orderstatus";

  const navigateToOrderStatus = (event) => {
    const GetOId = event.target.getAttribute("Oid");
    const GetCId = event.target.getAttribute("Cid");
    navigate(OrderStatusURL, { state: { GetOId, GetCId } });
  };

  // Responsive Navigate
  const navigateto = useNavigate();

  if (!location.pathname.includes("/myaccount") && width > breakpoint) {
    navigateto("/myaccount/myorder");
  }

  // get the data from API
  useEffect(() => {
    getOrderHistory({
      customer_id: userData.customerId,
      path: localStorage.getItem("path") || "",
    });
  }, []);

  if (error) {
    return <div>Error: {error}</div>;
  }

  const orderhistorydatas = orderhistory?.message; // Assign to a separate variable

  const handleOrderAgain = (orderId, client_id, clientPath) => {
    const formData = {
      client_id: client_id,
      order_id: orderId,
    };
    console.log(formData);
    reOrder(formData)
      .then((response) => {
        console.log(response);
        if (response.status === false) {
          console.log(response.message);
        } else {
          const orderAgainData = JSON.stringify(response?.message?.item);
          localStorage.setItem("cart", orderAgainData);
          const totalPrice = response?.message?.item.reduce(
            (sum, item) => sum + parseFloat(item.price),
            0
          );
          const totalCount = response?.message?.item.reduce(
            (sum, item) => sum + parseFloat(item.count),
            0
          );
          localStorage.setItem("cartQty", totalCount);
          localStorage.setItem("totalPrice", totalPrice);
          localStorage.setItem("cartClientPath", clientPath);
          navigate(`/${clientPath}/menu`);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  if (isLoading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center", // Center horizontally
          alignItems: "center", // Center vertically
          height: "100vh", // Full viewport height
          width: "100%", // Full viewport width
        }}
      >
        <Spinner
          animation="border"
          size="md"
          variant="success"
          style={{
            display: "flex", // Use flexbox
            justifyContent: "center", // Center horizontally
            alignItems: "center",
          }}
        />
      </div>
    );
  }

  return (
    <section>
      {width > breakpoint ? (
        <>
          <div className="yourorder-fk">
            <Container>
              <div className="mb-4">
                <h5 className="arrow-tablebooking-text pt-2">Your Order</h5>
              </div>
              {/* <div className='textfield-search'>
                    <TextField
                      className='search-feild'
                      variant="outlined"
                      size='small'
                      placeholder="Search For Takeawayname...."
                      onChange={(e) => setSearchOrder(e.target.value)}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon className='searchicon' />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </div> */}
              <div className="row g-2">
                {currentItems && currentItems.length > 0 ? (
                  currentItems
                    .filter((v) =>
                      searchOrder
                        ? v?.takeawayName
                            ?.toString()
                            ?.toLowerCase()
                            ?.includes(searchOrder.toLowerCase())
                        : true
                    )
                    .map((OrderDetail, index) => (
                      <div className="col-md-4" key={index}>
                        <div className="card-order w-100 h-100 border">
                          <div className="order-container">
                            <div className="g">
                              <img
                                src={restarantInfo?.backgroundImage || ''}
                                alt="order"
                                className="order-imagefirst"
                              />
                            </div>
                            <div className="order-data pt-2 pb-0 row">
                              <div className="col-12">
                                <h6 className="mb-0">
                                  {/* {OrderDetail.orderedDate}{" "} */}
                                  <span className="text-black fw-bold">
                                    {OrderDetail.takeawayName}
                                  </span>
                                </h6>
                              </div>
                            </div>

                            <div className="order-data pb-0 d-flex align-items-center justify-content-between">
                              <div className="">
                                <h6>
                                  <span className="amount-color fw-bold">
                                    £ {OrderDetail.orderTotalAmount}
                                  </span>
                                </h6>
                              </div>

                              <div className="">
                                <h6>
                                  <span
                                    className={
                                      OrderDetail.orderDeliveryStatus ==
                                      "Rejected"
                                        ? "reject-messagebutn"
                                        : OrderDetail.orderDeliveryStatus ==
                                          "Delivered"
                                        ? "delivery-messagebutn"
                                        : "current-messagebutn"
                                    }
                                  >
                                    {OrderDetail.orderDeliveryStatus == ""
                                      ? "Current"
                                      : OrderDetail.orderDeliveryStatus}
                                  </span>
                                </h6>
                              </div>
                            </div>

                            <h6 className="order-data d-flex align-items-center  justify-content-between">
                              <span>
                                <CiCalendarDate size={18} />
                                <span className="ms-1">
                                  {OrderDetail?.orderedDate}
                                </span>
                              </span>
                              <span>
                                <RiBox3Line size={18} />
                                <span className="ms-1">
                                  #{OrderDetail?.orderId}
                                </span>
                              </span>
                            </h6>

                            <div className="row">
                              <div className="col-12">
                                {OrderDetail.orderStatus === "reorder" ? (
                                  <Button
                                    className="button-reorder"
                                    onClick={() =>
                                      handleOrderAgain(
                                        OrderDetail.orderId,
                                        OrderDetail.clientId,
                                        OrderDetail.clientPath
                                      )
                                    }
                                  >
                                    Reorder
                                  </Button>
                                ) : (
                                  <Button
                                    className="button-reorder"
                                    Oid={OrderDetail.orderId}
                                    Cid={OrderDetail.clientId}
                                    onClick={navigateToOrderStatus}
                                  >
                                    Track Order
                                  </Button>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))
                ) : (
                  <div className="no-favourites text-center">
                    <img
                      src={img}
                      alt="No favourites"
                      style={{ width: "100px" }}
                    />
                    <h5>No Order Found!</h5>
                    <button
                      className="btn btn-dark mt-2"
                      onClick={() => navigate("/list")}
                    >
                      Find food
                    </button>
                  </div>
                )}
              </div>

              {/* Pagination Controls */}
              {/* {totalPages > 1 && (
                <div className="paginationorder">
                  <button
                    onClick={handlePreviousPage}
                    disabled={currentPage === 1}
                  >
                    Previous
                  </button>
                  <span> {currentPage} </span>
                  <span>{totalPages}</span>
                  <button
                    onClick={handleNextPage}
                    disabled={currentPage === totalPages}
                  >
                    Next
                  </button>
                </div>
              )} */}
              {totalPages > 1 ? (
                <div className="d-flex justify-content-end pagniation_mui mt-4">
                  <Pagination
                    count={totalPages}
                    page={currentPage}
                    size="large"
                    onChange={(e, v) => {
                      setCurrentPage(v);
                    }}
                    variant="outlined"
                    shape="rounded"
                  />
                </div>
              ) : null}
            </Container>
          </div>
        </>
      ) : (
        <>
          <div className="yourorder-fk mt-4">
            <Container>
              {/* <div className='textfield-search'>
                <TextField
                  className='search-feild'
                  variant="outlined"
                  size='small'
                  placeholder="Search For Takeawayname.."
                  onChange={(e) => setSearchOrder(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon className='searchicon' />
                      </InputAdornment>
                    ),
                  }}
                />
              </div> */}
              {orderhistorydatas?.length > 0 ? (
                orderhistorydatas
                  .filter((v) =>
                    searchOrder
                      ? v?.takeawayName
                          ?.toString()
                          ?.toLowerCase()
                          ?.includes(searchOrder.toLowerCase())
                      : true
                  )
                  .map((OrderDetail, index) => (
                    <div className="card-order border mb-4" key={index}>
                      <div className="order-container">
                        <div className="g">
                          <img
                            src={restarantInfo?.backgroundImage}
                            alt="order"
                            className="order-imagefirst"
                          />
                        </div>
                        <div className="order-data pt-4 pb-0 row">
                          <div className="col-12">
                            <h6 className="mb-0">
                              {/* {OrderDetail.orderedDate}{" "} */}
                              <span className="text-black fw-bold">
                                {OrderDetail.takeawayName}
                              </span>
                            </h6>
                          </div>
                        </div>

                        <div className="order-data pb-0 d-flex align-items-center justify-content-between">
                          <div className="">
                            <h6>
                              <span className="amount-color fw-bold">
                                £ {OrderDetail.orderTotalAmount}
                              </span>
                            </h6>
                          </div>

                          <div className="">
                            <h6>
                              <span
                                className={
                                  OrderDetail.orderDeliveryStatus == "Rejected"
                                    ? "reject-messagebutn"
                                    : OrderDetail.orderDeliveryStatus ==
                                      "Delivered"
                                    ? "delivery-messagebutn"
                                    : "current-messagebutn"
                                }
                              >
                                {OrderDetail.orderDeliveryStatus == ""
                                  ? "Current"
                                  : OrderDetail.orderDeliveryStatus}
                              </span>
                            </h6>
                          </div>
                        </div>

                        <h6 className="order-data d-flex align-items-center  justify-content-between">
                          <span>
                            <CiCalendarDate size={25} />
                            <span className="ms-1">
                              {OrderDetail?.orderedDate}
                            </span>
                          </span>
                          <span>
                            <RiBox3Line size={25} />
                            <span className="ms-1">
                              #{OrderDetail?.orderId}
                            </span>
                          </span>
                        </h6>

                        <div className="row">
                          <div className="col-12">
                            {OrderDetail.orderStatus === "reorder" ? (
                              <Button
                                className="button-reorder w-100"
                                onClick={() =>
                                  handleOrderAgain(
                                    OrderDetail.orderId,
                                    OrderDetail.clientId,
                                    OrderDetail.clientPath
                                  )
                                }
                              >
                                Reorder
                              </Button>
                            ) : (
                              <Button
                                className="button-reorder w-100"
                                Oid={OrderDetail.orderId}
                                Cid={OrderDetail.clientId}
                                onClick={navigateToOrderStatus}
                              >
                                Track Order
                              </Button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    // <div key={index} className="card-order">
                    //   <div className="order-container">
                    //     <h6 className="order-header">
                    //       <img
                    //         src={OrderDetail.logo}
                    //         alt="order-image"
                    //         className="order-imagefirst"
                    //       />
                    //       <span className="restaurant-yourname">
                    //         {OrderDetail.takeawayName}
                    //       </span>
                    //       <span className="waiting-messagebutn">
                    //         {OrderDetail.orderDeliveryStatus}
                    //       </span>
                    //     </h6>
                    //     <p className="ptag-order"></p>
                    //   </div>
                    //   <h6 className="order-data">
                    //     {OrderDetail?.orderedDate}{" "}
                    //     <span className="amount-color">
                    //       £ {OrderDetail?.orderTotalAmount}
                    //     </span>
                    //     <span
                    //       className="view-menutxt"
                    //       Oid={OrderDetail?.orderId}
                    //       Cid={OrderDetail?.clientId}
                    //       Path={OrderDetail?.clientPath}
                    //       onClick={navigateToOrderDetail}
                    //     >
                    //       View Bill
                    //     </span>
                    //   </h6>
                    //   <div className="buttonorder-divbtn">
                    //     {OrderDetail.orderStatus === "reorder" ? (
                    //       <Button
                    //         className="button-reorder"
                    //         onClick={() =>
                    //           handleOrderAgain(
                    //             OrderDetail.orderId,
                    //             OrderDetail.clientId,
                    //             OrderDetail.clientPath
                    //           )
                    //         }
                    //       >
                    //         <img
                    //           src="https://fusionbucket.co.uk/My-account/refresh.image.png"
                    //           alt="reorder-image"
                    //           className="reorder-image"
                    //         />
                    //         Reorder
                    //       </Button>
                    //     ) : (
                    //       <Button
                    //         className="button-reorder"
                    //         Oid={OrderDetail.orderId}
                    //         Cid={OrderDetail.clientId}
                    //         onClick={navigateToOrderStatus}
                    //       >
                    //         View Status
                    //       </Button>
                    //     )}
                    //   </div>
                    // </div>
                  ))
              ) : (
                <div className="d-flex justify-content-center text-center">
                  <div className="no-favourites">
                    <img
                      src={img}
                      alt="No favourites"
                      style={{ width: "100%" }}
                    />
                    <h5 className="menutext">No Booking Available!</h5>
                    <div className="menudevbutton mt-2">
                      <button
                        className="btn btn-dark"
                        onClick={() => navigate("/list")}
                      >
                        Menu
                      </button>
                    </div>
                  </div>
                </div>
              )}

              {totalPages > 1 ? (
                <div className="d-flex justify-content-end pagniation_mui">
                  <Pagination
                    count={totalPages}
                    page={currentPage}
                    size="large"
                    onChange={(e, v) => {
                      setCurrentPage(v);
                    }}
                    variant="outlined"
                    shape="rounded"
                  />
                </div>
              ) : null}

              {/* {totalPages > 1 && (
                <div className="paginationorder">
                  <button
                    onClick={handlePreviousPage}
                    disabled={currentPage === 1}
                  >
                    Previous
                  </button>
                  <span> {currentPage} </span>
                  <span>{totalPages}</span>
                  <button
                    onClick={handleNextPage}
                    disabled={currentPage === totalPages}
                  >
                    Next
                  </button>
                </div>
              )} */}
            </Container>
          </div>
        </>
      )}
    </section>
  );
};

const mapStateToProps = (state) => ({
  orderhistory: state.orderhistory.orderhistory,
  isLoading: state.orderhistory.isLoading,
  userData: state.userdata.userData,
  orderagain: state.orderagain.orderagain,
});

const mapDispatchToProps = {
  getOrderHistory,
};

export default connect(mapStateToProps, mapDispatchToProps)(Yourorder);
